// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1nHj-","title":"AfterBackImages_title__1U_FU","images":"AfterBackImages_images__e1Jfh"};